import styled from 'styled-components'

export const Lista = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 32px;
  column-gap: 36px;
  row-gap: 40px;
  padding: 0;
  list-style: none;
  align-items: stretch;

  li {
    display: flex;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 16px;
  }
`
